import { Col, Form, Modal, Row, Spin } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import 'moment/locale/th';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Layout from '../../../layouts/User';
import ProductSummary from './ProductSummary';
import ShippingInfo from './ShippingInfo';
import {
  getOrderById,
  saveOrder,
  updateOrderStore,
} from '../../../reducers/actions/order';
import { getSettings } from '../../../reducers/actions/setting';
import { isEmpty } from 'lodash';

moment.locale('th');

const breadcrumbs = [
  { text: 'หน้าแรก', path: '/' },
  { text: 'ตะกร้าสินค้า', path: '/cart' },
  { text: 'สรุปรายการสั่งซื้อ', path: '/confirm-order-summary' },
];

const OrderSummary: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [form] = Form.useForm();
  const { order, settings, spening } = useSelector(
    (state: any) => state
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const orderId = searchParams.get('id');

  useEffect(() => {
    if (orderId) {
      getOrderById(orderId).then((data) => {
        dispatch(updateOrderStore(data.data));
        form.setFieldsValue(data.data);
      });
    }
  }, [orderId]);

  useEffect(() => {
    if (isEmpty(settings)) {
      getSettings().then((data) => {
        dispatch(data);
      });
    }
  }, [settings]);

  const save = async (values: any) => {
    await saveOrder(order, values);
    navigate(`/cart/confirm-payment?id=${searchParams.get('id')}`);
  };

  const onFormFinish = async (values: any) => {
    if (order.promotionError && order.promotionError !== '') {
      Modal.confirm({
        title: 'ท่านใส่โค้ดส่วนลดไม่ถูกต้อง',
        icon: <ExclamationCircleOutlined />,
        content: 'กดชำระเงินเพื่อชำระเงินโดยไม่ใช้โค้ดส่วนลด',
        okText: 'ชำระเงิน',
        cancelText: 'แก้ไขโค้ดส่วนลด',
        onOk: () => save(values),
        onCancel: () => {},
      });
    } else {
      await saveOrder(order, values);
      navigate(`/cart/confirm-payment?id=${searchParams.get('id')}`);
    }
  };

  return (
    <>
      <Spin size="large" spinning={spening} delay={0}>
        <Layout
          breadcrumbItems={breadcrumbs}
          breadcrumbMarginBottom={16}
        >
          <Form form={form} onFinish={onFormFinish} layout="vertical">
            <Row justify="space-around">
              <Col style={{ padding: '16px 0' }} flex={1}>
                <b style={{ fontSize: '16px' }}>รายการสั่งซื้อ</b>
                <ProductSummary form={form} />
              </Col>
              <Col style={{ padding: '16px 0' }} flex={1}>
                <b style={{ fontSize: '16px' }}>การจัดส่ง</b>
                <ShippingInfo form={form} />
              </Col>
            </Row>
          </Form>
        </Layout>
      </Spin>
    </>
  );
};

export default OrderSummary;
